'use strict';

import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout     from '@Layout/BackOffice'
import UpdateForm from '@/Form/UpdateForm'
import _config    from '@Config/Catalog/partner'

import _ from 'lodash'


export default class PartnerModificationPage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			data: { }
		};
	}

	componentWillMount ()
	{
		var component = this;

		app.resetFunctions();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		qwest.post('/CMS/get', { id: id, model: 'partner' })
		.then(function (xhr, response)
		{
			component.setState({ data: response.data })
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const props = this.props, state = this.state;

		let config = _.cloneDeep(_config);

		let allowed_fields =
		[
			'name',
			'address_1',
			'address_1',
			'city',
			'zip_code',
			'phone',
			'email',
			'website',
			'twitter',
			'facebook',
			'instagram',
			'informations',
			'logo',
			'images'
		];

		config.can_delete = false;

		Object.keys(config.fields).forEach(function (field)
		{
			if (allowed_fields.includes(field) !== true)
			{
				delete config.fields[field];
			}
			else
			{
				config.fields[field].front_indicator = false;
			}
		});

		config.collapses = config.collapses
		.filter(function (collapse)
		{
			collapse.elements = collapse.elements.filter(function (name)
			{
				if (typeof name !== 'string') return false;

				return allowed_fields.includes(name);
			});

			return collapse.elements.length > 0;
		});

		if (!config.collapses.length) delete config.collapses;

		config.views = config.views
		.filter(function (view)
		{
			return allowed_fields.includes(view.source_field);
		});

		if (!config.views.length) delete config.views;

		let discount;

		if (state.data)
		{
			discount =
			(
				<div dangerouslySetInnerHTML={
					{ __html: state.data.discount_infos } }></div>
			);
		}

		var output =
		(
			<Layout page_title="Informations partenaire" history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<div className="c-title">
							<h2 className="c-title__txt">{ state.data.name }</h2>
						</div>

						<div className="page-txt">
							{ discount }
						</div>

						<TransitionGroup className="u-full-width">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ enter: 240, exit: 320, appear: 500 }}>

								<UpdateForm config={ config } hide_title={ true } />


							</CSSTransition>

						</TransitionGroup>


					</div>

				</div>

			</Layout>
		);

		return output;
	}
}